import i18n from "./i18n.ts";

const salaryCapFreeAgents =
	"You cannot go over the salary cap to sign free agents to contracts higher than the minimum salary.";

const salaryCapPlayers =
	"You cannot go over the salary cap to sign players to contracts higher than the minimum salary.";

export const localizeNegotiationError = (message: string) => {
	if (message === salaryCapFreeAgents) {
		return i18n.t("negotiation.disabledSalaryCapFreeAgents", {
			ns: "ui",
			defaultValue: salaryCapFreeAgents,
		});
	}

	if (message === salaryCapPlayers) {
		return i18n.t("negotiation.disabledSalaryCapPlayers", {
			ns: "ui",
			defaultValue: salaryCapPlayers,
		});
	}

	return message;
};
